var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex mt-24"},[_c('div',{staticClass:"full overflow-auto"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }